import React, {useRef, useState} from 'react';
import Form, {FormInputComponent} from "../../../components/form/Form";
import {useTalentCandidateScope} from "./TalentCandidateScopeProvider";

const CandidateCoverLetterEditTab = (props) => {

    const {
        candidate,
        isLoading: isLoadingCandidate,
        isDisabled,
        onUpdateProposal,
        onChange,
        updateCandidateScope,
        confirmTalentScope,
        resetModel
    } = useTalentCandidateScope();

    const [formId, setFormId] = useState(1);
    const formRef = useRef(null);
    const fieldProps = ['cover_letter','relevant_experience']

    const [formModel, setFormModel] = useState(TB.pick(candidate?.job_candidate || {}, fieldProps));


    const mapping = (model) => {
        model.cover_letter = model.cover_letter || '';
        model.relevent_experience = model.relevent_experience || '';
        return model;
    }

    const hasFormModelChanged = () => {
        let opp = mapping( TB.pick(candidate?.job_candidate || {}, fieldProps));
        let model = mapping(TB.pick(formModel, fieldProps))
        return !TB.isEqual(opp, model)
    }

    const resetForm = async() => {
        let model = TB.pick(candidate?.job_candidate || {}, fieldProps)

        model = mapping(model);

        await formRef.current.forceReset(model);
        await formRef.current.formRef.current.formsyForm.setFormPristine(true);
        await setFormModel(model)
        await setFormId(formId+1)
    }
    const submitForm = async() => {
        let invalid = formRef.current.forceValidate(formModel);
        if (invalid) {
            return;
        }
        let response = await updateCandidateScope(formModel, false);

        if (response) {
            return TB.toast('Candidate Proposal Updated')
        }
    }

    if (isLoadingCandidate || !candidate) {
        return null
    }
    return (
        <React.Fragment>
            <Form
                ref={formRef}
                key={formId}
                onSubmit={submitForm}
                mapping={mapping}
                submitButton={false}
                isDisabled={isDisabled}
                model={formModel}
                onChange={model => setFormModel({
                    ...formModel, ...model
                })}
                minimal
                background={"none"}
                fields={[]}
            >
                <div className="flex flex-row items-start gap-4">
                    <div className="flex-1">
                        <FormInputComponent
                            fieldName={'cover_letter'}
                            value={formModel.cover_letter}
                            disabled={false}
                            required={false}
                            label="Cover Letter"
                            type="editor"
                            tools={['bold', 'italic', 'underline', 'link', 'ol', 'ul']}
                        />
                    </div>
                    <div className="flex-1">
                        <FormInputComponent
                            fieldName={'relevant_experience'}
                            value={formModel.relevant_experience}
                            disabled={false}
                            required={false}
                            label="Relevant Experience"
                            type="editor"
                            tools={['bold', 'italic', 'underline', 'link', 'ol', 'ul']}
                        />
                    </div>
                </div>
                {/*{candidate.canEditCandidateScope() && (*/}

                <div className="flex flex-row items-center gap-3 justify-end mt-4 mb-2">
                    <button type="button"
                            className="btn btn-outline-dark" onClick={resetForm}
                            disabled={isDisabled || !hasFormModelChanged()}>
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary"
                            disabled={isDisabled || !hasFormModelChanged()}>
                        Update
                    </button>
                </div>

                {/*)}*/}
            </Form>


        </React.Fragment>
    );
}

export default CandidateCoverLetterEditTab;